import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

export interface MetricCardProps {
  title: string;
  value: string | number | null;
  subtitle?: string;
  /** Highlight colour for the value text */
  valueColor?: string;
  testId?: string;
}

/**
 * Scalar metric display card — CSS-only, no charting lib (D-G-5).
 * Used for: conversion rate, no-show rate, avg cycle time, jobs in progress.
 */
const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  valueColor = '#111827',
  testId,
}) => {
  const displayValue = value === null || value === undefined ? '—' : value;

  return (
    <Card
      size="small"
      data-testid={testId}
      style={{ height: '100%' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>{title}</Text>
        <span
          style={{
            fontSize: 28,
            fontWeight: 700,
            lineHeight: 1.2,
            color: valueColor,
          }}
          data-testid={testId ? `${testId}-value` : undefined}
        >
          {displayValue}
        </span>
        {subtitle && (
          <Text type="secondary" style={{ fontSize: 11 }}>{subtitle}</Text>
        )}
      </div>
    </Card>
  );
};

export default MetricCard;
